export default "__VITE_ASSET__BfFosl1n__"